import { InMemoryCache, ApolloClient } from '@apollo/client'
import buildHasuraProvider from 'ra-data-hasura'

// import customBuildArgs from './customBuildArgs'
import customBuildArgs from './customBuildArgs'
import customBuildFields from './customBuildFields'
import customBuildMetaArgs from './customBuildMetaArgs'
import customBuildVariables from './customBuildVariables'
import hasuraHeaders from './hasuraHeaders'
import proxyDataProvider from './proxyDataProvider'

const hasuraGraphQLUrl = process.env.REACT_APP_HASURA_URL

const dataProvider = async ({ setDataProvider }) => {
  const client = new ApolloClient({
    uri: hasuraGraphQLUrl,
    headers: hasuraHeaders(),
    cache: new InMemoryCache(),
  })

  const hasuraDataProvider = await buildHasuraProvider(
    { client },
    {
      buildFields: customBuildFields,
      buildArgs: customBuildArgs,
      buildMetaArgs: customBuildMetaArgs,
    },
    customBuildVariables
  )

  const result = proxyDataProvider(hasuraDataProvider)

  setDataProvider(() => result)
}

export default dataProvider
